/**
 * @module ButtonIcons
 */
/* eslint-disable no-unused-vars */
import React from 'react';

const FacebookIcon = () => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99735 22.5V13.5547H7V10H9.99735V7.19922C9.99735 4.15625 11.8575 2.5 14.5735 2.5C15.8748 2.5 16.9925 2.59766 17.3168 2.64062V5.82031H15.4332C13.956 5.82031 13.6708 6.52344 13.6708 7.55078V10H17.0042L16.547 13.5547H13.6708V22.5"
      fill="#009ECC"
      fillOpacity="0.5"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg
    fill="none"
    height="25"
    viewBox="0 0 24 25"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3663 7.56163C9.70617 7.56163 7.55929 9.70851 7.55929 12.3687C7.55929 15.0288 9.70617 17.1757 12.3663 17.1757C15.0265 17.1757 17.1734 15.0288 17.1734 12.3687C17.1734 9.70851 15.0265 7.56163 12.3663 7.56163ZM12.3663 15.4929C10.646 15.4929 9.2421 14.089 9.2421 12.3687C9.2421 10.6484 10.646 9.24445 12.3663 9.24445C14.0866 9.24445 15.4905 10.6484 15.4905 12.3687C15.4905 14.089 14.0866 15.4929 12.3663 15.4929ZM17.3702 6.24445C16.7491 6.24445 16.2476 6.74601 16.2476 7.3671C16.2476 7.9882 16.7491 8.48976 17.3702 8.48976C17.9913 8.48976 18.4929 7.99054 18.4929 7.3671C18.4931 7.21962 18.4642 7.07355 18.4078 6.93726C18.3515 6.80097 18.2688 6.67714 18.1645 6.57285C18.0602 6.46857 17.9364 6.38588 17.8001 6.32953C17.6638 6.27317 17.5177 6.24426 17.3702 6.24445ZM21.7366 12.3687C21.7366 11.0749 21.7484 9.79288 21.6757 8.50148C21.603 7.00148 21.2609 5.67023 20.164 4.57335C19.0648 3.47413 17.7359 3.13429 16.2359 3.06163C14.9421 2.98898 13.6601 3.0007 12.3687 3.0007C11.0749 3.0007 9.79288 2.98898 8.50148 3.06163C7.00148 3.13429 5.67023 3.47648 4.57335 4.57335C3.47413 5.67257 3.13429 7.00148 3.06163 8.50148C2.98898 9.79523 3.0007 11.0773 3.0007 12.3687C3.0007 13.6601 2.98898 14.9444 3.06163 16.2359C3.13429 17.7359 3.47648 19.0671 4.57335 20.164C5.67257 21.2632 7.00148 21.603 8.50148 21.6757C9.79523 21.7484 11.0773 21.7366 12.3687 21.7366C13.6624 21.7366 14.9444 21.7484 16.2359 21.6757C17.7359 21.603 19.0671 21.2609 20.164 20.164C21.2632 19.0648 21.603 17.7359 21.6757 16.2359C21.7507 14.9444 21.7366 13.6624 21.7366 12.3687ZM19.6741 17.8952C19.503 18.3218 19.2968 18.6405 18.9663 18.9687C18.6359 19.2991 18.3194 19.5054 17.8929 19.6765C16.6601 20.1663 13.7327 20.0562 12.3663 20.0562C10.9999 20.0562 8.07023 20.1663 6.83742 19.6788C6.41085 19.5077 6.0921 19.3015 5.76398 18.971C5.43351 18.6405 5.22726 18.3241 5.05617 17.8976C4.56867 16.6624 4.67882 13.7351 4.67882 12.3687C4.67882 11.0023 4.56867 8.07257 5.05617 6.83976C5.22726 6.4132 5.43351 6.09445 5.76398 5.76632C6.09445 5.4382 6.41085 5.2296 6.83742 5.05851C8.07023 4.57101 10.9999 4.68117 12.3663 4.68117C13.7327 4.68117 16.6624 4.57101 17.8952 5.05851C18.3218 5.2296 18.6405 5.43585 18.9687 5.76632C19.2991 6.09679 19.5054 6.4132 19.6765 6.83976C20.164 8.07257 20.0538 11.0023 20.0538 12.3687C20.0538 13.7351 20.164 16.6624 19.6741 17.8952Z"
      fill="#00B3E5"
      fillOpacity="0.5"
    />
  </svg>
);

const ShareIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 2.58582L12.7071 3.29292L17.7071 8.29292L16.2929 9.70714L13 6.41424V16H11V6.41424L7.70711 9.70714L6.29289 8.29292L11.2929 3.29292L12 2.58582ZM3 16H5V19H19V16H21V19V21H19H5H3V19V16Z"
      fill="#009ECC"
      fillOpacity="0.5"
      fillRule="evenodd"
    />
  </svg>
);

export { FacebookIcon, InstagramIcon, ShareIcon };
